module.exports = __webpack_public_path__ + "static/media/xiv-minions.d298a002.jpg";